import {
  Card,
  CardHeader,
  CardMedia,
  CardContent,
  CardActions,
  CardActionArea,
  Button,
  Link,
  Typography,
  Avatar,
} from "fashion/fabrics";
import { SearchIcon, BookIcon } from "fashion/icons";
import { BlogPost } from "names/blog";
import BlogHeaderShare from "nodes/blog/BlogHeaderShare";

type Props = {
  post: BlogPost;
};

const CARD_BANNER_HEIGHT = 150;

const BlogCard = ({ post }: Props) => (
  <Card elevation={6}>
    <CardHeader
      avatar={
        <Avatar>
          <BookIcon />
        </Avatar>
      }
      action={<BlogHeaderShare post={post} />}
      title="Blog Article"
      subheader={post.date}
    />
    <CardActionArea component={Link} href={post.route}>
      <CardContent>
        <Typography fontWeight="500" variant="body2" noWrap>
          {post.name}
        </Typography>
      </CardContent>
      <CardMedia
        component="img"
        height={CARD_BANNER_HEIGHT}
        image={post.imgSrc}
        alt="Article Banner"
      />
    </CardActionArea>
    <CardActions disableSpacing>
      <Button
        component={Link}
        href={post.route}
        startIcon={<SearchIcon />}
        fullWidth
        color="secondary"
      >
        View Article
      </Button>
    </CardActions>
  </Card>
);

export default BlogCard;
